const config = {
  gatsby: {
    pathPrefix: '/docs',
    siteUrl: 'https://loadfocus.com',
    gaTrackingId: 'UA-39927583-1',
    trailingSlash: false,
  },
  404: {
    title: 'Documentation | LoadFocus',
    description: 'Documentation built with mdx. ',
  },
  header: {
    logo: 'https://d2woeiihr4s5r6.cloudfront.net/logos/logo-loadfocus-white.svg',
    logoLink: 'https://loadfocus.com/',
    title: "<a class='header-link' href='https://loadfocus.com/docs/'>" +
      "<span class='header-link-separator'></span>" +
      "<span class='header-link-text'>docs</span>" +
      "</a>",
    githubUrl: '',
    helpUrl: '',
    tweetText: '',
    social: ``,
    links: [
      { text: 'Pricing', link: 'https://loadfocus.com/pricing' },
      { text: 'Blog', link: 'https://loadfocus.com/blog' },
      { text: 'Login', link: 'https://loadfocus.com/login' },
      { text: 'Sign Up', link: 'https://loadfocus.com/pricing' },
    ],
    search: {
      enabled: true,
      indexName: 'Docs',
      algoliaAppId: 'A5NLY0PW6M',
      algoliaSearchKey: '9e89401c1902a94845c2934608b6243a',
      algoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY || '',
    },
  },
  sidebar: {
    forcedNavOrder: [
      '/guides',
      '/knowledge-base',
      '/pricing',
    ],
    collapsedNav: [
      '/knowledge-base',
    ],
    links: [
      { text: 'Start Testing Now', link: 'https://loadfocus.com/pricing' },
    ],
    linksNormal: [
      { text: '© LoadFocus - Privacy Policy', link: 'https://loadfocus.com/privacy' },
    ],
    frontline: false,
    ignoreIndex: true,
    title: false,
  },
  siteMetadata: {
    title: 'Documentation | LoadFocus',
    description: 'LoadFocus Documentation.',
    ogImage: 'https://d2woeiihr4s5r6.cloudfront.net/logos/logo-loadfocus-white.svg',
    docsLocation: '',
    favicon: 'https://d2woeiihr4s5r6.cloudfront.net/documentation/favicon/favicon.ico',
  },
  pwa: {
    enabled: false, // disabling this will also remove the existing service worker.
    manifest: {
      name: 'LoadFocus Documentation',
      short_name: 'LoadFocus Docs',
      start_url: '/',
      background_color: '#6b37bf',
      theme_color: '#6b37bf',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      icons: [
        {
          src: 'src/pwa-512.png',
          sizes: `512x512`,
          type: `image/png`,
        },
      ],
    },
  },
};

module.exports = config;
